import { Menu, MenuItem } from '@mui/material';

type MenuOption = {
  label: string;
  onClick: () => void;
};

type ContextMenuProps = {
  anchor: { mouseX: number; mouseY: number } | null;
  onClose: () => void;
  options: MenuOption[];
};

export const ContextMenu: React.FC<ContextMenuProps> = ({
  anchor,
  onClose,
  options
}) => {
  return (
    <Menu
      open={Boolean(anchor)}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        anchor ? { top: anchor.mouseY, left: anchor.mouseX } : undefined
      }
    >
      {options.map((option, index) => (
        <MenuItem key={index} onClick={option.onClick}>
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};
